import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FETCH_FORM = createAsyncActionTypes('FETCH_FORM');